import { useState } from 'react';
import { Button, Message, Label, Icon } from 'semantic-ui-react';
import { useUpdateDiscountItem } from "./hooks/useUpdateDiscountItem";

const EmailCSVUpload = () => {
	const [error, setError] = useState(null);
	const [fileName, setFileName] = useState(null);
    const updateDiscountItem = useUpdateDiscountItem();

	const parseCSV = (text) => {
		const emails = [];
		const lines = text.split(/\r?\n/);
		
		for (const line of lines) {
			// Split by comma and trim whitespace
			const values = line.split(',').map(v => v.trim());
			
			for (const val of values) {
				// Basic email validation
				if (val && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
					emails.push(val);
				}
			}
		}
		
		return emails;
	};

	const handleFileChange = (e) => {
		const file = e.target.files[0];
		if (!file) return;

		setFileName(file.name);
		setError(null);

		// Check file type
		if (!file.name.endsWith('.csv') && !file.type.includes('csv')) {
			setError('Please upload a CSV file');
			return;
		}

		const reader = new FileReader();
		
		reader.onload = (event) => {
			try {
				const text = event.target.result;
				const emails = parseCSV(text);

				if (emails.length === 0) {
					setError('No valid emails found in the file');
					return;
				}

                updateDiscountItem("bulk_emails", emails);
			} catch (err) {
				setError('Error parsing CSV file: ' + err.message);
			}
		};

		reader.onerror = () => {
			setError('Error reading file');
		};

		reader.readAsText(file);
	};

	const handleClear = () => {
		setFileName(null);
		setError(null);
        updateDiscountItem("bulk_emails", {});
	};

	return (
		<>
			<div>
				<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
					<Button
						as="label"
						htmlFor={`csv-upload-emails`}
						icon
						labelPosition="left"
						primary
						basic
					>
						<Icon name="upload" />
						Upload CSV
					</Button>
					<input
						id={`csv-upload-emails`}
						type="file"
						accept=".csv"
						style={{ display: 'none' }}
						onChange={handleFileChange}
					/>
					{fileName && (
						<>
							<Label>
								<Icon name="file" />
								{fileName}
							</Label>
							<Button
								icon="x"
								size="mini"
								basic
								onClick={handleClear}
							/>
						</>
					)}
				</div>
				
				{error && (
					<Message negative size="small" style={{ marginTop: '10px' }}>
						<Message.Header>Upload Error</Message.Header>
						<p>{error}</p>
					</Message>
				)}
			</div>
			<p className='mt-2'>Note: You can only upload the CSV once when creating the Health Credit</p>
		</>

	);
};

export default EmailCSVUpload;
